<app-filter-editor></app-filter-editor>

<ngx-masonry [updateLayout]="updateMasonryLayout" [options]="myOptions">
  <div ngxMasonryItem class="masonry-item" *ngFor="let image of images;let i = index" (click)="focusImage=i">
    <div class="image-container" >
      <img [src]="image.thumbUrl" (load)="imagesLoaded(image)">
      <div class="description-overlay">
        {{image.title}}<br><br>
        <div class="inv-nr">INVENTAR-NR: {{image.invNumber}}</div>
      </div>
    </div>
  </div>
</ngx-masonry>
<app-loading-indicator *ngIf="apiService.isLoading"></app-loading-indicator>
<div class="nothing" *ngIf="!apiService.isLoading && images.length==0">Nichts gefunden</div>

<div class="image-modal" *ngIf="focusImage>=0" (click)="focusImage=-1" [style.width]="screenWidth" [style.height]="screenHeight">

  <div class="content">
    {{focusImage+1}} / {{images.length}}
    <div class="title">
      {{images[focusImage].title}}
    </div>
  </div>

  <div class="img-nav nav-back" (click)="navBack($event)"> <i class="arrow left"></i></div>
  <div class="img-nav nav-next" (click)="navNext($event)"><i class="arrow right"></i></div>

  <div class="image-box">
    <img [src]="images[focusImage].imageUrl">
  </div>

</div>
